module.exports = __webpack_public_path__ + "static/img/logo_02.2d9f7a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/relay-event/logo_02.png
// module id = s9FD
// module chunks = 0